import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Container, Card, Row, Col, Input, Button } from 'reactstrap'
import ReactTable from 'react-table';
import BackButton from '../../../../../../designUtils/Logo/BackButton.svg';
import CustomModal from '../../../../../Components/Modals/CustomModal';
import FetchEmployeeOffboardingMembersService from '../../../../../../Service/OPSServices/EmployeeOffboardingService/FetchEmployeeOffboardingMembersService';
import DeactivateEmployeeOffboardingService from '../../../../../../Service/OPSServices/EmployeeOffboardingService/DeactivateEmployeeOffboardingService';
import EmployeeOffboardingActiveWork from './Component/EmployeeOffboardingActiveWork';
import TransferActiveWork from './Component/TransferActiveWork';

const emptyTransferred = { tasks: 0, workflows: 0, tickets: 0 };

function EmployeeOffboardingMainPage(props) {
  const [view, setView] = useState('list');
  const [searchText, setSearchText] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [tab, setTab] = useState('tasks');
  const [assignments, setAssignments] = useState({});
  const [transferred, setTransferred] = useState(emptyTransferred);
  const [roleAssignments, setRoleAssignments] = useState({});
  const [storeRolesTransferred, setStoreRolesTransferred] = useState(false);
  const [modal, setModal] = useState(null);
  const [people, setPeople] = useState([]);

  const refreshPeople = () => {
    FetchEmployeeOffboardingMembersService(props.token, {}).then((res) => {
      if (res && res.success) {
        setPeople(res.members);
        setSelectedPerson(prev => prev ? (res.members.find(m => m.id === prev.id) || prev) : prev);
      }
    });
  };

  useEffect(() => {
    refreshPeople();
  }, [props.token]);

  const closeModal = () => setModal(null);
  const showInfo = (title, body) => setModal({
    title,
    body,
  });
  const showConfirm = (title, body, confirmLabel, onConfirm, danger) => setModal({
    title,
    body,
    confirmLabel,
    onConfirm,
    danger,
  });

  const deactivateEmployee = () => {
    if (!selectedPerson) return;
    DeactivateEmployeeOffboardingService(props.token, { memberId: selectedPerson.id }).then((res) => {
      if (!res || !res.success) {
        showInfo("Deactivate Failed", <p>{(res && res.message) || 'Employee could not be deactivated, please try again.'}</p>);
        return;
      }
      setSelectedPerson(null);
      setView('list');
      refreshPeople();
    });
  };

  const selectPerson = (person) => {
    setSelectedPerson(person);
    setAssignments({});
    setTransferred(emptyTransferred);
    setRoleAssignments({});
    setStoreRolesTransferred(false);
    setTab('tasks');
    setView('overview');
  };

  const header = (title, sub, onBack) => (
    <Card className='card-of-problemarea p-3 mb-3'>
      <Row className='align-items-center'>
        <Col md={12}>
          <div className='eo-title-row'>
            <div className='d-flex align-items-start'>
              {onBack && (
                <button
                  className="back-button-header mr-3"
                  onClick={onBack}
                  style={{
                    padding: 0,
                    border: "none",
                    background: "transparent",
                  }}
                >
                  <img src={BackButton} alt="Back" />
                </button>
              )}
              <div>
                <h5 className={`eo-title ${sub ? '' : 'mb-0'}`}>{title}</h5>
                {sub && <p className='eo-subtitle'>{sub}</p>}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );

  const filteredPeople = people.filter(p => `${p.name} ${p.email} ${p.role}`.toLowerCase().includes(searchText.toLowerCase()));

  const employeeColumns = [
    {
      Header: 'Employee',
      accessor: 'name',
      Cell: (cellInfo) => (
        <div>
          <div className='eo-name'>{cellInfo.value}</div>
          <div className='eo-muted'>{cellInfo.original.email}</div>
        </div>
      ),
    },
    // {
    //   Header: 'Role',
    //   accessor: 'role',
    //   Cell: (cellInfo) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="m-0">{cellInfo.value}</p>
    //     </div>
    //   ),
    // },
    {
      Header: 'Active Work',
      accessor: 'activeItems',
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <span className='eo-pill eo-pill-orange'>{cellInfo.value} Active Items</span>
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'id',
      sortable: false,
      Cell: () => (
        <div className="d-flex justify-content-center w-100">
          <span className='eo-pill eo-pill-green'>Active</span>
        </div>
      ),
    },
    {
      Header: 'Action',
      accessor: 'id',
      id: 'action',
      sortable: false,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <Button className='btn-background-color' size='sm' onClick={() => selectPerson(cellInfo.original)}>Manage</Button>
        </div>
      ),
    },
  ];

  const renderList = () => (
    <>
      {header("Employee Offboarding")}
      <Card className='card-of-problemarea p-4'>
        <Row className='justify-content-end'>
          <Col md={4}>
            <Input
              type='text'
              placeholder='Search employee by name, email or role...'
              className='mb-3'
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ReactTable
              data={filteredPeople}
              columns={employeeColumns}
              className="-fixed -highlight -striped"
              getTheadProps={() => {
                return {
                  style: {
                    overflowY: "hidden",
                    background: "#B1FA63",
                  },
                };
              }}
              defaultPageSize={10}
              noDataText={"No Data Found."}
            />
          </Col>
        </Row>
      </Card>
    </>
  );

  return (
    <Container fluid className='eo-page'>
      <Row>
        <Col md={12}>
          {view === 'list' && renderList()}
          {view === 'overview' && (
            <EmployeeOffboardingActiveWork
              selectedPerson={selectedPerson}
              header={header}
              onBack={() => setView('list')}
              onStartTransfer={() => setView('transfer')}
            />
          )}
          {view === 'transfer' && (
            <TransferActiveWork
              token={props.token}
              selectedPerson={selectedPerson}
              header={header}
              onBack={() => setView('overview')}
              showInfo={showInfo}
              showConfirm={showConfirm}
              onDeactivate={deactivateEmployee}
              onTasksTransferred={refreshPeople}
              tab={tab}
              setTab={setTab}
              assignments={assignments}
              setAssignments={setAssignments}
              transferred={transferred}
              setTransferred={setTransferred}
              roleAssignments={roleAssignments}
              setRoleAssignments={setRoleAssignments}
              storeRolesTransferred={storeRolesTransferred}
              setStoreRolesTransferred={setStoreRolesTransferred}
            />
          )}
        </Col>
      </Row>
      <CustomModal
        header={modal ? modal.title : ''}
        isOpen={!!modal}
        toggle={closeModal}
        size={"md"}
        className='curve-popup'
      >
        <Card className='curve-popup p-3'>
          <Row>
            <Col md={12}>
              {modal && modal.body}
            </Col>
            <Col md={12} className='d-flex justify-content-end mt-3'>
              {modal && modal.onConfirm ? (
                <>
                  <Button
                    className='btn-background-color-cancle mr-2'
                    onClick={closeModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    color={modal.danger ? 'danger' : undefined}
                    className={modal.danger ? 'eo-btn-danger' : 'btn-background-color'}
                    onClick={() => {
                      modal.onConfirm();
                      closeModal();
                    }}
                  >
                    {modal.confirmLabel}
                  </Button>
                </>
              ) : (
                <Button className='btn-background-color' onClick={closeModal}>
                  OK
                </Button>
              )}
            </Col>
          </Row>
        </Card>
      </CustomModal>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
  };
};

export default connect(mapStateToProps)(EmployeeOffboardingMainPage);
